// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2e3dl","unreadBadge":"styles_unreadBadge__1FOCS","modalContent":"styles_modalContent__3JfvR","modal":"styles_modal__1VHoH"};